import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

// One write refreshes every dependent view. entity → query-key path prefixes.
const MAP = {
  account: ["/api/accounts", "/api/bookings", "/api/calls", "/api/metrics", "/api/mrr", "/api/leads", "/api/pipeline", "/api/admin/account"],
  booking: ["/api/bookings", "/api/metrics", "/api/accounts", "/api/leads"],
  call: ["/api/calls", "/api/metrics", "/api/mrr", "/api/accounts"],
  subscription: ["/api/mrr", "/api/metrics", "/api/accounts"],
  setter: ["/api/setter", "/api/metrics"],
  drill: ["/api/drills"],
  report: ["/api/reports"],
  mrr: ["/api/mrr", "/api/metrics"],
  settings: ["/api/settings", "/api/sync", "/api/accounts", "/api/leads", "/api/metrics", "/api/mrr", "/api/bookings", "/api/calls"],
  research: ["/api/accounts"],
  admin: ["/api"],
  all: ["/api"],
} as const;

export type InvalidateEntity = keyof typeof MAP;

export function invalidate(...entities: InvalidateEntity[]) {
  const prefixes = new Set<string>();
  for (const e of entities) for (const p of MAP[e]) prefixes.add(p);
  queryClient.invalidateQueries({
    predicate: (q) => {
      const k = q.queryKey[0];
      return typeof k === "string" && [...prefixes].some((p) => k.startsWith(p));
    },
  });
}
